export default __webpack_public_path__ + "df6b6652e653bf74d8167a1a387a97a3.png";